// tslint:disable
export const dicoSPR = {
    id: "1",
    cover: {
        image: "safir",
        title: "Safir Plus Revenus",
        target: "Particuliers âgés de 35 ans à 76 ans inclus.",
        topic:
            "Un contrat d’épargne et de prévoyance couvrant l’état de perte d’autonomie totale par le versement " +
            "d’une rente mensuelle viagère et la constitution d’une épargne jusqu’à 85 ans.",
        tag: "Dépendance",
        age: "35 / 76 ans",
    },
    conditions: [
        "Être âgé(e) d’au moins 35 ans et moins de 77 ans.",
        "Être affilié à un régime français ou monégasque de Sécurité sociale",
    ],
    plus: [
        { icon: "medical", text: "Une sélection médicale simplifiée : une seule question avant 70 ans" },
        { icon: "currency", text: "Une rente dépendance totale garantie à vie" },
        { icon: "shield", text: "Couverture immédiate en cas d’accident" },
        {
            icon: "calcul",
            text: "Le maintien de garanties réduites en cas d’arrêt de paiement des cotisations, après 8 ans d’adhésion*",
        },
        { icon: "currency", text: "La possibilité d’utiliser librement les capitaux et les rentes versés" },
        { icon: "account", text: "Des services d’assistance essentiels" },
    ],

    /* DOCUMENTS ANNEXES */

    docs: {
        adhesion: [
            {
                label: "Notice d'information",
                url: require("./documents/adhesion/spr_notice_information.pdf"),
                required: true,
            },
            {
                label: "Déclaration de santé dépendance",
                url: require("./documents/adhesion/spr_declaration_de_sante.pdf"),
                required: true,
            },
            {
                label: "Guide pratique dépendance",
                url: require("./documents/adhesion/spr_guide_pratique_dependance.pdf"),
                required: false,
            },
            {
                label: "Fiches conseils dépendance",
                url: require("./documents/adhesion/spr_fiches_conseils_dependance.pdf"),
                required: false,
            },
        ],
        common: [
            {
                label: "Plaquette commerciale",
                url: require("./documents/common/safir_plus_revenus_plaquette_commerciale.pdf"),
                required: false,
            },
            { label: "Fiche IPID", url: require("./documents/common/fiche_IPID_spr.pdf"), required: true },
            {
                label: "Dossier d’Entrée en Relation (DER)",
                url: require("../common/documents/DER_Prévoyance_Individuelle_Dynamique.pdf"),
                required: true,
            },
        ],
    },

    /********************/

    summary: {
        image: "safir",
        ratio: "portrait",
        paragraphs: [
            {
                headline: "Niveaux de garanties",
                text: "<ul><li>Rente mensuelle de 150 € à 1 500 € en cas de dépendance totale. </li><li>Constitution d’une épargne disponible jusqu’à 85 ans.</li></ul>",
            },
            {
                headline: "Délai de carence",
                text: "<ul><li>Aucun délai de carence en cas d’accident.</li><li> 1 an en cas de maladie.</li><li> 3 ans en cas de maladie neurologique.</li></ul>",
            },
            {
                headline: "Cotisations",
                text: "<ul><li>Le montant de la cotisation est fixé en fonction de l’âge de l’adhérent à la date d’effet de l’adhésion et du montant du capital garanti. </li><li>Le versement des cotisations cesse à 85 ans.</li></ul>",
            },
        ],
    },
    details: {
        paragraphs: [
            {
                headline: "Rente mensuelle à vie",
                text:
                    "<b>Jusqu’à 85 ans, votre cotisation vous permet :</b><ul><li>De percevoir une rente mensuelle à vie de 150 à 1 500 € en cas de dépendance totale,</li><li>De vous constituer une épargne.</li></ul>" +
                    "<b>À 85 ans, vous cessez de cotiser et vous avez le choix :</b><ul><li>Soit de doubler votre garantie rente dépendance initiale en investissant votre épargne,</li>" +
                    "<li>Soit de récupérer votre épargne, tout en conservant votre garantie rente dépendance initiale.</li></ul>" +
                    "<b>Vous bénéficiez également des garanties d’assistance spécifiques qui favorise le maintien à domicile.</b>",
            },
            {
                headline: "La sélection médicale",
                text: "<ul><li>Déclaration d’État de Santé (1 question avant 70 ans et 3 au-delà),</li><li>Questionnaire médical approfondi si au moins 1 oui à la DES.</li></ul>",
            },
            {
                headline: "Prima assistance",
                text: "N° appel d’assistance : <ul><li>N° tél. : 0 800 10 00 10 (appel gratuit depuis un poste fixe)</li><li>N° de protocole : 621 525</li><li>N° PCV : 33 1 40 25 57 05 (appel depuis l’étranger)</li></ul>",
            },
            {
                headline: "Des services d’assistance essentiels",
                text:
                    "Différences services assistances sont à votre disposition:<ul><li>Services « vie quotidienne » : informations juridiques, médicales, mise en relation avec des artisans...,</li>" +
                    "<li>Services « dépendance temporaire » : transfert à l’hôpital, aide à la recherche d’une infirmière, livraison de médicaments...,</li>" +
                    "<li>En cas de maladie ou de décès lors d’un déplacement, prise en charge de l’avance des frais médicaux ou rapatriement,</li>" +
                    "<li>Assistance « maintien à domicile » : Organisation des services d’aide à domicile : aide ménagère, portage des repas, téléassistance...</li></ul>",
            },
        ],
        mentions: ["* Maintien d’un niveau réduit de la garantie rente immédiate dépendance totale."],
    },
    benchmark: {
        title: "Safir Plus Revenus",
        head: [
            { headline: "" },
            { headline: "ag2r La Mondiale", subheading: "Garantie Prévoyance Individuelle" },
            { headline: "BANQUE POPULAIRE", subheading: "Fructi-Famille" },
            { headline: "BNP PARIBAS", subheading: "Protection familiale" },
            { headline: "ALLIANZ", subheading: "Allianz Prévoyance" },
            { headline: "LCL", subheading: "Prévillon" },
        ],
        body: [
            {
                cells: [
                    "Garanties",
                    "- Capital décès / invalidité<br>- Indemnités journalières<br>- Exonérations des paiements<br>- Option doublement accident",
                    "- Capital décès<br>- Capital invalidité",
                    "- Capital décès<br>- Capital invalidité<br>- Rente éducation<br>- Option doublement accident",
                    "- Capital décès / invalidité<br>- Indemnités journalières<br>- Exonérations des paiements<br>- Rente au conjoint<br>- Rente éducation",
                    "- Capital décès<br>- Capital invalidité<br>- Rente éducation<br>- Doublement et triplement accident",
                ],
            },
            {
                cells: [
                    "Formalités médicales",
                    "Déclaration d’Etat de Santé <br/>< 51 ans et pour un capital max de 100 000 euros<br/><br/>Questionnaire Médical > 51 ans",
                    "Déclaration  de Santé<br>< 55 ans pour un capital max de 100 000€<br/><br/>Questionnaire Médical > 55 ans ",
                    "Questionnaire de santé simplifiée<br><69 ans pour un capital max de 50 000€<br/><br/>Questionnaire Médical entre 49 ans et 69 ans pour un capital compris entre 69 000€  175 000€",
                    "Formalités médicales en fonction du capital souscrit et de l‘âge",
                    "Déclaration de santé < 60 ans pour un capital maximum de 30 000€<br /><br/>Questionnaire de santé pour un capital compris entre 30 000 et 75 000 €",
                ],
            },
            {
                cells: [
                    "Montants des capitaux",
                    "Entre 10 000 € et 200 000 € ",
                    "Entre 15 000 € et 149 000 € (tranche de  1 000 €)",
                    "Entre 30 000 € et  300 000 € (tranche de  2 000 €)",
                    "À partir de 15 000 € (Libre choix)",
                    "Entre 16 000 € et  75 000 € (Libre choix)",
                ],
            },
            {
                highlight: true,
                cells: [
                    "Tarifs mensuels* (45 ans)",
                    "Pour 30 000 € de capital : 9,87 €",
                    "Pour 30 000 € de capital : 14,03 €",
                    "Pour 30 000 € de capital : 13,21 €",
                    "Pour 30 000 € de capital : 9,90  €",
                    "Pour 30 000 € de capital : 12,36 €",
                ],
            },
            {
                highlight: true,
                cells: [
                    "Tarifs mensuels* (55 ans)",
                    "Pour 30 000 € de capital : 21,52 €",
                    "Pour 30 000 € de capital : 30,28 €",
                    "Pour 30 000 € de capital : 32,12 €",
                    "Pour 30 000 € de capital : 25,44 €",
                    "Pour 30 000 € de capital : 29,03 €",
                ],
            },
        ],
        mention:
            "<sup>*</sup> Les tarifs n’incluent pas les garanties IPT et ITT et autres garanties optionnelles que peuvent proposer certains assureurs.",
    },
};



// WEBPACK FOOTER //
// ./src/data/products/spr/dico.ts